import { apiRequest, apiRequestBlob } from '@/services/http'
import type { TalentProfile } from '@/features/profile/api'

/**
 * `bs-talent.profiles.cvs[]`, addressed by array INDEX (the schema has no per-entry id — same
 * convention `employment`/`education` already use). Every call returns the WHOLE updated
 * profile, same shape `getMyProfile()`/`updateMyProfile()` return, so the caller can just replace
 * its local profile state rather than re-deriving one array out of a partial response.
 */
export function uploadResume(file: File, displayName?: string): Promise<{ profile: TalentProfile }> {
  const form = new FormData()
  form.append('file', file)
  if (displayName) form.append('displayName', displayName)
  return apiRequest('/v1/profile/cvs', { method: 'POST', body: form })
}

export function updateResume(
  index: number,
  input: { displayName?: string; isSelected?: boolean },
): Promise<{ profile: TalentProfile }> {
  return apiRequest(`/v1/profile/cvs/${index}`, { method: 'PATCH', body: JSON.stringify(input) })
}

export function deleteResume(index: number): Promise<{ profile: TalentProfile }> {
  return apiRequest(`/v1/profile/cvs/${index}`, { method: 'DELETE' })
}

/** The raw file bytes — an authenticated fetch, not a plain `<iframe src>` (that sends no bearer
 * token). The caller turns this into an object URL for inline preview or download. */
export function getResumeFile(index: number): Promise<Blob> {
  return apiRequestBlob(`/v1/profile/cvs/${index}/file`)
}
